import React from "react";
import AllShops from "../components/shop/AllShops";
import Footer from "../components/shared/footer/Footer";
import Header from "../components/shared/header/Header";

const Shops = () => {
  return (
    <div>
      <Header />
      <AllShops />
      <Footer />
    </div>
  );
};

export default Shops;
